import { $generateNodesFromDOM } from '@lexical/html';
import { $createTextNode } from 'lexical';

import { isHtml, parseToHtml } from './string';

const SPECIAL_CHARS = '_';
const TRIGGERS = '@';
const VALID_CHARS = `[^${TRIGGERS}${SPECIAL_CHARS}\\s]`;
const LENGTH_LIMIT = 50;
const AT_SIGN_MENTION_REGEX = new RegExp(
  `(^|\\s|\\()(` +
    `[${TRIGGERS}]` +
    `((?:${VALID_CHARS}){0,${LENGTH_LIMIT}})` +
    `)$`
);

export const $createWhitespace = () => $createTextNode(' ');

export const $generateNodesFromStr = (str, editor) => {
  if (!isHtml(str)) {
    return [$createTextNode(str)];
  }

  return $generateNodesFromDOM(editor, parseToHtml(str));
};

export const getAtSignMentionMatch = (text) => {
  const match = AT_SIGN_MENTION_REGEX.exec(text);

  if (match !== null) {
    const maybeLeadingWhitespace = match[1];
    const matchingString = match[3];

    return {
      leadOffset: match.index + maybeLeadingWhitespace.length,
      matchingString,
      replaceableString: match[2],
    };
  }

  return null;
};

export const makeUnifiedNodesConfig = (configs) => {
  const result = [];

  for (const config of configs) {
    config(result);
  }

  return result;
};
